interface IProductTranslation {
  lang: string;
  name: string;
}

interface IProductWithTranslations {
  name?: string;
  translations?: IProductTranslation[];
}

export const getProductTranslationName = (
  product: IProductWithTranslations | undefined,
  language: string,
): string => {
  if (!product) {
    return "";
  }

  if (language && product.translations?.length) {
    const translation = product.translations.find(
      (trans) => trans.lang === language,
    );
    if (translation?.name) {
      return translation.name;
    }
  }

  return product.name || "";
};
